import React from 'react';
import { Pressable, StyleSheet } from 'react-native';
import { Text } from './Texte';
import { colors, radius, spacing, typography } from '../theme/tokens';

interface CheckboxProps {
  label: string;
  checked: boolean;
  onToggle: (next: boolean) => void;
  testID?: string;
}

export function Checkbox({ label, checked, onToggle, testID }: CheckboxProps) {
  return (
    <Pressable
      testID={testID}
      accessibilityRole="checkbox"
      accessibilityState={{ checked }}
      onPress={() => onToggle(!checked)}
      style={styles.row}
    >
      <Text style={[styles.box, checked && styles.boxChecked]}>{checked ? '✓' : ''}</Text>
      <Text style={styles.label}>{label}</Text>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  row: { flexDirection: 'row', alignItems: 'center', gap: spacing.sm },
  box: {
    width: 22,
    height: 22,
    borderRadius: radius.sm,
    borderWidth: 2,
    borderColor: colors.grey400,
    textAlign: 'center',
    color: colors.white,
    overflow: 'hidden',
    lineHeight: 20,
  },
  boxChecked: { backgroundColor: colors.bluePrimary, borderColor: colors.bluePrimary },
  label: { fontSize: typography.body.size, color: colors.grey700 },
});
